import { useState } from 'react';
import bs58 from 'bs58';
import { Keypair } from '@solana/web3.js';
import { useClipboard } from '../../../Hooks/useClipboars';
import { toast } from 'react-toastify';
import { capitalizeFirstLetter } from '../../../utils/string';

interface Props {
    walletAddress: string;
    walletBalance: number;
    defaultSnipeSolValue: number;
    defaultSolInitialBuyValue: number;
    onInstantClick: (data: {
        instantType: 'pump' | 'bonk';
        mintSecretKeyBase58: string | undefined;
        snipeChecked: boolean;
        snipeSolValue: number;
        initBuySolValue: number;
    }) => void;
}

export function Instant({ walletAddress, walletBalance, defaultSnipeSolValue, defaultSolInitialBuyValue, onInstantClick }: Props) {
    const [instantType, setInstantType] = useState<'pump' | 'bonk'>('bonk');
    const [instantName, setInstantName] = useState<string>('Bonk');
    const [selected, setSelected] = useState<'suffix' | 'custom'>('suffix');
    const [customTokenPrivateKey, setCustomTokenPrivateKey] = useState<string>();
    const [snipeChecked, setSnipeChecked] = useState<boolean>(false);
    const [snipeSolValue, setSnipeSolValue] = useState<number>(defaultSnipeSolValue);
    const [initBuySolValue, setInitBuySolValue] = useState<number>(defaultSolInitialBuyValue);

    const { copyToClipboard } = useClipboard();

    return (
        <div className='instant-case'>
            <div className='instant-case-row'>
                <select
                    name='instantType'
                    className='instant-type'
                    value={instantType}
                    onChange={(e) => {
                        setInstantType(e.target.value as typeof instantType);
                        setInstantName(capitalizeFirstLetter(e.target.value));
                    }}
                >
                    <option value='pump'>Pump</option>
                    <option value='bonk'>Bonk</option>
                </select>
                <div className='wallet-balance-container'>
                    <p>Wallet Balance:</p>
                    <p>{walletBalance.toFixed(3)}</p>
                    <p className='wallet-address'>{walletAddress}</p>
                    <button className='copy-btn' onClick={() => copyToClipboard(walletAddress)}></button>
                </div>
            </div>
            <div className='instant-case-row instant-case-radio'>
                <label className='radio-option'>
                    <input
                        type='radio'
                        className='option'
                        value='suffix'
                        checked={selected === 'suffix'}
                        onChange={(e) => setSelected(e.target.value as typeof selected)}
                    />
                    <div>
                        <p>{instantName}</p>
                        <p>Suffix</p>
                    </div>
                </label>
                <label className='radio-option'>
                    <input
                        type='radio'
                        className='option'
                        value='custom'
                        checked={selected === 'custom'}
                        onChange={(e) => setSelected(e.target.value as typeof selected)}
                    />
                    <div>
                        <p>Custom</p>
                        <p>Wallet</p>
                    </div>
                </label>

                <input
                    type='text'
                    className='custom-wallet-address'
                    placeholder='Enter custom private key'
                    value={customTokenPrivateKey}
                    onChange={(e) => setCustomTokenPrivateKey(e.target.value)}
                    disabled={selected !== 'custom'}
                />
            </div>
            <div className='instant-case-row'>
                <button
                    className={`action instant-${instantType}`}
                    onClick={() => {
                        let mintSecretKeyBase58: string | undefined = undefined;
                        if (selected === 'custom') {
                            try {
                                Keypair.fromSecretKey(bs58.decode(customTokenPrivateKey ?? ''));
                                mintSecretKeyBase58 = customTokenPrivateKey;
                            } catch {
                                toast.error('Invalid private key');
                                return;
                            }
                        }

                        onInstantClick({
                            instantType,
                            mintSecretKeyBase58,
                            snipeChecked,
                            snipeSolValue,
                            initBuySolValue,
                        });
                    }}
                >
                    Instant {instantName.toUpperCase()}
                </button>
                <div className='sol-initial-buy-case'>
                    <h3>Dev Buy</h3>
                    <input
                        type='number'
                        value={initBuySolValue}
                        onChange={(event) => {
                            const value = parseFloat(event.target.value);
                            setInitBuySolValue(value);
                        }}
                    />
                </div>
            </div>
            <div className='instant-case-row'>
                <div className='second-wallet-snipe-container instant-second-wallet'>
                    <label>
                        <input type='checkbox' className='autocap-checkbox' checked={snipeChecked} onChange={() => setSnipeChecked(!snipeChecked)} />
                        <b>Snipe wallet</b>
                    </label>
                    <label>
                        <input
                            className='second-wallet-snipe-input'
                            value={snipeSolValue}
                            type='number'
                            onChange={(e) => {
                                setSnipeSolValue(parseFloat(e.target.value));
                            }}
                        />
                        <b>SOL</b>
                    </label>
                </div>
            </div>
        </div>
    );
}
